import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import AgentModel from "../models/AgentModel";
import AgentQueryModel from "../models/AgentQueryModel";

export interface SearchAgentParam {
    pageSize: number,
    query: AgentQueryModel
}

export interface GetAgentByIdParam {
    id: string,
}

export interface GetAgentByIdsParam {
    ids: string[],
}

export interface DeleteAgentByIdParam {
    id: string,
}
export interface SearchAgentNameParam {
    keyword: string,
}

const AgentApi = {
    SearchName(param: SearchAgentNameParam) {
        return Api.get<SearchAgentNameParam, BaseResponse<AgentModel[]>>("/api/Agent/SearchName", param);
    },
    GetAll() {
        return Api.get<unknown, BaseResponse<AgentModel[]>>("/api/Agent/GetAll", null);
    },
    Search(param: SearchAgentParam) {
        return Api.post<SearchAgentParam, BaseResponse<AgentModel[]>>("/api/Agent/Search", param);
    },
    Save(param: AgentModel) {
        return Api.post<AgentModel, BaseResponse<AgentModel>>("/api/Agent/Save", param);
    },
    GetById(param: GetAgentByIdParam) {
        return Api.get<GetAgentByIdParam, BaseResponse<AgentModel>>("/api/Agent/GetById", param);
    },
    GetByIds(param: GetAgentByIdsParam) {
        return Api.get<GetAgentByIdsParam, BaseResponse<AgentModel[]>>("/api/Agent/GetByIds", param);
    },
    Delete(param: DeleteAgentByIdParam) {
        return Api.post<DeleteAgentByIdParam, BaseResponse<AgentModel>>("/api/Agent/Delete", param);
    },
};
export default AgentApi;